module.exports = __webpack_public_path__ + "static/josie-4c1723e58ba24cdc7514c88664b81b91.jpg";